/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { BehaviorSubject } from "rxjs";
import { Router, RouterStateSnapshot } from "@angular/router";
import { Location } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class ApiCollectionService {
  URL = {
    collections: "/inventorygroupsets",
    deleteCollections: "/inventorygroupsetsgroupactions",
    deleteGroup: "/inventorygroupsetgroupsgroupactions",
    updateCollections: "/inventorygroupsets/",
    updateBoardPosition: "/inventorygroupsetspositionchange",
    createCollectionGroup: "/inventorygroupsetgroups",
  };
  public salesPersons = [];
  public collectionBoards = [];
  public spDetails;
  isCollectionsDialogOpen = new BehaviorSubject(false);
  wishlistDialogRef;
  cartDialogRef;
  collectionDialogRef;
  constructor(
    private http: HttpClient,
    private router: Router,
    private location: Location
  ) {}

  pushCurrentState() {
    const snapshot: RouterStateSnapshot = this.router.routerState.snapshot;
    let url = snapshot.url;
    if (this.location.isCurrentPathEqualTo(url)) {
      this.router.navigate([url], { skipLocationChange: true });
    } else {
      history.pushState({}, null, window.location.href);
    }
  }

  getCollections(id, isOwner?, typeName?, onlyBoardTypes?, boardGroups?) {
    let httpParams = new HttpParams().set("businessUnitId", id);
    if (isOwner) {
      httpParams = httpParams.set("isOwner", isOwner);
    }
    if (typeName) {
      httpParams = httpParams.set("typeName", typeName);
    }
    if (onlyBoardTypes) {
      httpParams = httpParams.set("onlyBoardTypes", onlyBoardTypes);
    }
    if (boardGroups) {
      httpParams = httpParams.set("boardGroups", "true");
    }
    return this.http.get<any>(environment.server + this.URL.collections, {
      params: httpParams,
    });
  }
  deleteCollection(collectionArray) {
    let collections = {
      inventroryGroupSets: collectionArray,
      groupActions: {
        isDisable: true,
      },
    };
    return this.http.post<any>(
      environment.server + this.URL.deleteCollections,
      collections
    );
  }
  updateCollection(collections) {
    return this.http.put<any>(
      environment.server + this.URL.updateCollections + collections._id,
      collections
    );
  }

  updateBoardPosition(data) {
    return this.http.put<any>(
      environment.server + this.URL.updateBoardPosition,
      data
    );
  }
  delete(data) {
    return this.http.put<any>(
      environment.server + this.URL.updateBoardPosition,
      data
    );
  }
  deleteGroup(collectionArray) {
    return this.http.post<any>(
      environment.server + this.URL.deleteGroup,
      collectionArray
    );
  }

  createGroups(data) {
    return this.http.post<any>(
      environment.server + this.URL.createCollectionGroup,
      data
    );
  }

  updateGroup(data) {
    return this.http.put<any>(
      environment.server + this.URL.createCollectionGroup + "/" + data.id,
      data
    );
  }

  getCollectionGroups(id) {
    const httpParams = new HttpParams().set("businessUnitId", id);
    return this.http.get<any>(
      environment.server + this.URL.createCollectionGroup,
      {
        params: httpParams,
      }
    );
  }
}
